(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.controller.debt-financing
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn debt-financing
  [{:keys [report-data] :as props}]
  {:debt-financing-text (report-ctl/rich-content props :debt-financing-text)
   :debt-key-figures    (report-ctl/with-footnote
                         props
                         :debt-key-figures-footnotes
                         (:portfolio-debt-key-figures report-data))})
